import { render, staticRenderFns } from "./ClientAddressUpdate.vue?vue&type=template&id=5666e158&"
import script from "./ClientAddressUpdate.vue?vue&type=script&lang=js&"
export * from "./ClientAddressUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports